T.Form.Count = Class(
	/**
	 * @lends {T.Form.Count#}
	 */
	{
		__construct(par) {
			this.par = par || {};
			this._n = ++T.Form.Count._n;
			this._value = typeof par.value !== 'undefined' ? Math.min(par.max, Math.max(par.min, par.value)) : par.min;

			this.node = mkE({
				tag: 'div',
				className: 't-form-count'
			});

			this._text = mkE({
				tag: 'div',
				className: 't-form-count-text',
				els: [
					this._textNode = mkE({
						tag: 'span',
						text: this._value
					})
				]
			}).append(this.node);

			mkE({
				tag: 'a',
				className: 'decrease',
				onclick: this._decrease
			}).append(this._text);

			mkE({
				tag: 'a',
				className: 'increase',
				onclick: this._increase
			}).append(this._text);
		},

		value(v) {
			if (typeof v === "undefined") {
				return this._value;
			}
			this._value = v;
			setNodeText(this._textNode, v);
			return this._value;
		},

		_increase() {
			let current = this.value();
			if (current === this.par.max) {
				return;
			}
			this.value(current + 1);
			this.par.onChange ? this.par.onChange() : D.doNothing();
		},

		_decrease() {
			let current = this.value();
			if (current === this.par.min) {
				return;
			}
			this.value(current - 1);
			this.par.onChange ? this.par.onChange() : D.doNothing();
		}
	},
	mkE.Base
);
T.Form.Count._n = 0;